import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(2, 0),
  },
  box: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    "@media(max-width:935px)": {
      flexDirection: "column",
    },
  },
  boxRow: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 450,
  },
  text: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
}));

export default useStyles;
